/* eslint-disable react/jsx-props-no-spreading */
import { memo, useMemo } from 'react';
import PropTypes from 'prop-types';

import Creole from 'app/marketplace/vehicle/Remarks/CreoleParser';
import {
  RemarkSt,
  PreviewTextSt,
} from 'app/marketplace/vehicle/Remarks/Remarks.css';
import { Row } from 'app/marketplace/shared/components/Row/Row';
import { cleanUpMarkdown } from 'app/marketplace/vehicle/utils';

const creole = new Creole();

const injectHtml = (string) => ({
  __html: creole.parse(string),
});

const RemarksCmp = ({ remarks }) => {
  const cleanRemarks = useMemo(() => injectHtml(cleanUpMarkdown(remarks)), [
    remarks,
  ]);

  return (
    <Row>
      <RemarkSt>
        <PreviewTextSt dangerouslySetInnerHTML={cleanRemarks} />
      </RemarkSt>
    </Row>
  );
};

RemarksCmp.propTypes = {
  remarks: PropTypes.string.isRequired,
};

export const Remarks = memo(RemarksCmp);
